import {
  ApplicationRef,
  CUSTOM_ELEMENTS_SCHEMA,
  Injector,
  DoBootstrap,
  NgModule
} from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { BrowserModule } from '@angular/platform-browser';
import { CsxSecurityModule, SecurityConfigInjectionToken } from '@csx/security';
import { RouterModule } from '@angular/router';

import {
  CommonModule,
  HashLocationStrategy,
  LocationStrategy
} from '@angular/common';
import {
  provideHttpClient,
  withInterceptorsFromDi
} from '@angular/common/http';
import {
  BrowserAnimationsModule,
  provideAnimations
} from '@angular/platform-browser/animations';
import { DialogService } from 'primeng/dynamicdialog';
import { SecConfig } from 'src/app/security/security.config';
import { LoadBundleGuard } from 'src/app/guards/load-bundle.guard';
import { WindowRef } from 'src/app/windowref';
import { IOHNotAuthorizedMessageComponent } from 'src/app/components/ioh-not-authorized-message/ioh-not-authorized-message.component';
import { IOHHomeComponent } from 'src/app/components/home/ioh-home.component';
import { MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import { CsxInternalToolsDarkPreset } from '@csx/clear-ng/presets';
@NgModule({
  imports: [
    BrowserModule,
    CommonModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(
      [
        {
          path: 'ioh/level/:levelId',
          component: IOHHomeComponent
        },
        {
          path: 'ioh/notauthorized',
          component: IOHNotAuthorizedMessageComponent,
          data: {
            adminEmail: ''
          }
        },
        {
          path: '**',
          redirectTo: 'ioh/level/level-1'
        }
      ],
      { useHash: true }
    ),
    CsxSecurityModule.componentInitialize()
  ],
  providers: [
    MessageService,
    DialogService,
    WindowRef,
    LoadBundleGuard,
    provideHttpClient(withInterceptorsFromDi()), // HTTP client configuration
    provideAnimations(),
    Location,
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    { provide: SecurityConfigInjectionToken, useValue: SecConfig },
    providePrimeNG({
      theme: {
        preset: CsxInternalToolsDarkPreset,
        options: {
          darkModeSelector: '.csx-dark'
        }
      }
    })
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ImodOperationsRealtimeModule implements DoBootstrap {
  constructor(private injector: Injector) {
  }
  ngDoBootstrap(appRef: ApplicationRef) {
    const el = createCustomElement(IOHHomeComponent, {
      injector:this.injector
    });
    customElements.define('csxwc-imod-operations-realtime', el);
  }
}
